import styles from './HeartIllustration.module.css';

export default function HeartIllustration() {
  return (
    <div className={styles.illustrationWrap}>
      {/* Concentric pulsing rings */}
      <div className={`${styles.ring} ${styles.ring1}`} />
      <div className={`${styles.ring} ${styles.ring2}`} />
      <div className={`${styles.ring} ${styles.ring3}`} />

      {/* ECG trace behind heart */}
      <div className={styles.ecgWrap}>
        <svg viewBox="0 0 120 48" xmlns="http://www.w3.org/2000/svg">
          <path
            className={styles.ecgLine}
            d="M0 24 L30 24 L38 24 L42 6 L48 42 L52 12 L56 30 L60 24 L90 24 L120 24"
          />
        </svg>
      </div>

      {/* Heart icon */}
      <img
        className={styles.heart}
        src="/assets/iCardio_Heart_only.svg"
        alt=""
        width={32}
        height={32}
      />
    </div>
  );
}
